import { getBasePath } from '@prophecy/utils/history';
import { matchPath } from 'react-router-dom';

import { replayToken } from '../../../../utils/replayToken';

export const getShareId = (pathname: string, searchParams: URLSearchParams) => {
  if (pathname.includes('/share/')) {
    const shareId = pathname.split('/').at(-1);
    return shareId ?? null;
  }
  const shareIdFromParams = searchParams.get('shareId');
  return shareIdFromParams ?? null;
};

export const isSharedProject = (url: string) => {
  const targetUrl = new URL(url, window.location.origin);
  const currentUrl = new URL(window.location.href);
  const pathMatches = matchPath({ path: targetUrl.pathname, end: true }, window.location.pathname);

  const paramsMatch = ['shareId', 'snapshotMode'].every((paramKey) => {
    const targetValue = targetUrl.searchParams.get(paramKey);
    if (targetValue === null) {
      return true;
    }
    return currentUrl.searchParams.get(paramKey) === targetValue;
  });

  return Boolean(pathMatches && paramsMatch);
};

export const getReplayId = (pathname: string, searchParams: URLSearchParams) => {
  if (pathname.includes('/replay/')) {
    const replayId = pathname.split('/').at(-1);
    return replayId ?? null;
  }
  const replayIdFromParams = searchParams.get('replayId');
  return replayIdFromParams ?? null;
};

export const isSharedReplay = (url: string) => {
  const targetUrl = new URL(getBasePath() + url, window.location.origin);

  const currentUrl = new URL(window.location.href);
  const currentReplayMode = currentUrl.searchParams.get('replayMode');

  const pathMatches = matchPath({ path: targetUrl.pathname, end: true }, window.location.pathname);

  const paramsMatch =
    targetUrl.searchParams.get('entity') === currentUrl.searchParams.get('entity') &&
    targetUrl.searchParams.get('name') === currentUrl.searchParams.get('name');

  if (currentReplayMode === 'edit') {
    return Boolean(pathMatches && paramsMatch && replayToken.hasDirectAccess);
  }

  return Boolean(pathMatches && paramsMatch);
};
